import React, { useEffect } from 'react';
import FormComponent from 'atoms/FormComponent';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import GlobalPaymentBillingandSaveTemplate from './GlobalPaymentBillingandSaveTemplate';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import PAYMENT_CONSTANTS from 'organisms/Payment/constants/PaymentConstants';
import { FORM_FIELD_TYPE, FORM_FIELD_DATA_TYPE } from 'common/constants/SharedConstants';

const { PAYMENT_CREDIT_DEBIT_CARD_VIEW_TEMPLATES } = PAYMENT_CONSTANTS;
export const onFormElementChangeHandler = (formConfig, fieldConfig) => {
  const fieldValues = formConfig?.getValueFromElements?.() ?? null;
  const paymentCardDetails = { ...formConfig?.checkoutDetails?.paymentCardDetails };
  if (fieldValues) {
    paymentCardDetails[fieldConfig?.name] = fieldValues?.[fieldConfig?.name];
  }
  paymentCardDetails.isFormValid = formConfig?.isFormValid;

  formConfig?.updateCheckoutDetails({
    paymentCardDetails,
    creditCardPaymentFormConfig: {
      ...formConfig?.checkoutDetails?.creditCardPaymentFormConfig,
      fieldsConfig: getUpdatedFieldsConfig(formConfig, fieldConfig, fieldValues),
      showSaveCardDetails: !fieldValues?.showSaveCardDetails,
    },
  });
};

export const checkconditionalrender = (data, fieldValues) => {
  if (
    data.name === PAYMENT_CREDIT_DEBIT_CARD_VIEW_TEMPLATES?.BILLING_ADDRESS ||
    data.name === PAYMENT_CREDIT_DEBIT_CARD_VIEW_TEMPLATES?.POSTAL_CODE
  ) {
    return fieldValues?.deliveryAddressCheckbox;
  } else if (data.name === PAYMENT_CREDIT_DEBIT_CARD_VIEW_TEMPLATES?.CARD_NICK_NAME) {
    return !fieldValues?.saveCard;
  }
};

export const getUpdatedFieldsConfig = (formConfig, fieldConfig, fieldValues) =>
  formConfig?.checkoutDetails?.creditCardPaymentFormConfig?.fieldsConfig?.map(data => {
    return {
      ...data,
      conditionalRender: checkconditionalrender(data, fieldValues),
    };
  });

const PaymentCreditDebitCardViewTemplates = props => {
  const { checkoutDetails, updateCheckoutDetails } = props;
  useEffect(() => {
    updateCheckoutDetails({
      creditCardPaymentFormConfig: {
        fieldsConfig: getFormConfigDetails(checkoutDetails),
        isFormValid: false,
        isFormReadOnly: false,
        onFormChangeHandler: onFormElementChangeHandler,
        showSaveCardDetails: false,
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={`cc-and-dc-form ${!checkoutDetails?.isAddNewCard ? 'cc-and-dc-form-checkout' : ''} `}>
      <div className='row row-cols-12 '>
        <div className={`${checkoutDetails?.isAddNewCard ? 'col-sm-4' : 'col-sm-12'} col-12`}>
          <div className={`labelContent ${checkoutDetails?.isAddNewCard ? 'labelContentAddNewCard' : ''} `}>
            <span>{translateWithI18Next(TRANSLATE_MAPPING_KEY?.CREDIT_CARD_DETAILS)}</span>
          </div>
        </div>
        <div className={`${checkoutDetails?.isAddNewCard ? 'col-sm-8' : 'col-sm-12'} col-12`}>
          <div>
            <FormComponent
              formConfig={{
                ...checkoutDetails?.creditCardPaymentFormConfig,
                checkoutDetails, // optional field belogs to checkout page
                updateCheckoutDetails, // optional field belogs to checkout page
                defaultValues: {
                  [PAYMENT_CREDIT_DEBIT_CARD_VIEW_TEMPLATES?.CARD_NUMBER_TITLE]: translateWithI18Next(
                    TRANSLATE_MAPPING_KEY?.CREDIT_CARD_DETAILS,
                  ),
                  [PAYMENT_CREDIT_DEBIT_CARD_VIEW_TEMPLATES?.BILLING_ADDRESS_TITLE]: translateWithI18Next(
                    TRANSLATE_MAPPING_KEY?.BILLING_ADDRESS,
                  ),
                },
              }}
            />
          </div>
        </div>
      </div>
      <div className={`row row-cols-12 billingaddress-container }`}>
        <div className={`${checkoutDetails?.isAddNewCard ? 'col-sm-4' : 'col-sm-12'} col-12`}>
          <div className={`labelContent ${checkoutDetails?.isAddNewCard ? 'labelContentBillingAddress' : ''} `}>
            <span>{translateWithI18Next(TRANSLATE_MAPPING_KEY?.BILLING_ADDRESS)}</span>
          </div>
        </div>
        <div className={`${checkoutDetails?.isAddNewCard ? 'col-sm-8' : 'col-sm-12'} col-12`}>
          <>
            <GlobalPaymentBillingandSaveTemplate
              checkoutDetails={checkoutDetails}
              updateCheckoutDetails={updateCheckoutDetails}
            />
          </>
        </div>
      </div>
    </div>
  );
};

export default React.memo(PaymentCreditDebitCardViewTemplates);

export const getFormConfigDetails = checkoutDetails => {
  const cardNumerConfig = {
    name: PAYMENT_CREDIT_DEBIT_CARD_VIEW_TEMPLATES?.CARD_NUMBER,
    label: () => translateWithI18Next(TRANSLATE_MAPPING_KEY?.CARD_NUMBER),
    type: FORM_FIELD_TYPE?.PAYMENT_TEXT_INPUT,
    dataType: FORM_FIELD_DATA_TYPE?.CARD_NUMBER,
    rules: {
      required: { value: true, message: () => translateWithI18Next(TRANSLATE_MAPPING_KEY?.ENTER_VALID_CARD_NUMBER) },
    },
    isMandatory: true,
    onChangeHandler: onFormElementChangeHandler,
    onBlurHandler: onFormElementChangeHandler,
  };

  const cardCVVConfig = {
    name: PAYMENT_CREDIT_DEBIT_CARD_VIEW_TEMPLATES?.CVV,
    label: () => translateWithI18Next(TRANSLATE_MAPPING_KEY?.CVV),
    type: FORM_FIELD_TYPE?.PAYMENT_TEXT_INPUT,
    dataType: FORM_FIELD_DATA_TYPE?.CARD_CVV,
    rules: {
      required: { value: true, message: () => translateWithI18Next(TRANSLATE_MAPPING_KEY?.ENTER_CVV_NUMBER) },
    },
    isMandatory: true,
    onChangeHandler: onFormElementChangeHandler,
    onBlurHandler: onFormElementChangeHandler,
  };

  const cardExpiryDateConfig = {
    name: PAYMENT_CREDIT_DEBIT_CARD_VIEW_TEMPLATES?.EXPIRY_DATE,
    label: () => translateWithI18Next(TRANSLATE_MAPPING_KEY?.EXPIRY_DATE_YY),
    type: FORM_FIELD_TYPE?.PAYMENT_TEXT_INPUT,
    dataType: FORM_FIELD_DATA_TYPE?.CARD_EXPIRY_DATE,
    rules: {
      required: {
        value: true,
        message: () => translateWithI18Next(TRANSLATE_MAPPING_KEY?.ENTER_VALID_CARD_EXPIRY_DATE),
      },
    },
    isMandatory: true,
    onChangeHandler: onFormElementChangeHandler,
    onBlurHandler: onFormElementChangeHandler,
  };

  const cardHolderNameConfig = {
    name: PAYMENT_CREDIT_DEBIT_CARD_VIEW_TEMPLATES?.NAME_ON_CARD,
    label: () => translateWithI18Next(TRANSLATE_MAPPING_KEY?.NAME_ON_CARD),
    type: FORM_FIELD_TYPE?.INPUT,
    pattern: PAYMENT_CREDIT_DEBIT_CARD_VIEW_TEMPLATES?.NAME_ON_CARD_INPUT_PATTERN,
    rules: {
      required: { value: true, message: () => translateWithI18Next(TRANSLATE_MAPPING_KEY?.ENTER_YOUR_NAME_ON_CARD) },
      pattern: {
        value: checkoutDetails?.nameOnCardRegex,
        message: () => translateWithI18Next(TRANSLATE_MAPPING_KEY?.INVALID_NAME),
      },
    },
    isMandatory: true,
    onChangeHandler: onFormElementChangeHandler,
    onBlurHandler: onFormElementChangeHandler,
  };

  return [
    // { ...cardDetailsTitleConfig },
    { ...cardHolderNameConfig },
    { ...cardNumerConfig },
    { ...cardCVVConfig },
    { ...cardExpiryDateConfig },
    // { ...billingAddressTitleConfig },
    // { ...deliveryAddressCheckBox },
    // { ...billingAddressConfig },
    // { ...postalCodeConfig },
    // { ...saveCardCheckBox },
    // { ...savedCardNickName },
  ];
};
